import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { Size } from 'src/app/interfaces/size';
import { SizesProviderService } from 'src/app/providers/sizes/sizes.provider.service';

@Injectable({
  providedIn: 'root'
})
export class SizesService extends ApiService<Size, SizesProviderService> {
  private sizesProviderService = inject(SizesProviderService);
  protected override get provider(): SizesProviderService {
    return this.sizesProviderService;
  }
}
